import { render, staticRenderFns } from "./ArticleMobile.vue?vue&type=template&id=6c0acd44"
import script from "./ArticleMobile.vue?vue&type=script&lang=js"
export * from "./ArticleMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports